import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreVert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_43205_4943)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5625 13.75C13.4254 13.75 14.125 13.0504 14.125 12.1875C14.125 11.3246 13.4254 10.625 12.5625 10.625C11.6996 10.625 11 11.3246 11 12.1875C11 13.0504 11.6996 13.75 12.5625 13.75Z",
				fill: "#535353"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5625 6.625C13.4254 6.625 14.125 5.92544 14.125 5.0625C14.125 4.19956 13.4254 3.5 12.5625 3.5C11.6996 3.5 11 4.19956 11 5.0625C11 5.92544 11.6996 6.625 12.5625 6.625Z",
				fill: "#535353"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5625 20.875C13.4254 20.875 14.125 20.1754 14.125 19.3125C14.125 18.4496 13.4254 17.75 12.5625 17.75C11.6996 17.75 11 18.4496 11 19.3125C11 20.1754 11.6996 20.875 12.5625 20.875Z",
				fill: "#535353"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_43205_4943",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMoreVert;
